"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getByIdTabName = exports.getTabNameById = void 0;
const constants_1 = require("../../constants");
/**
 * Returns the contentful tab name by priceTierId
 *
 * @param {string} tabId - priceTierId
 * @returns {string} - tab name or empty string if no match
 */
const getTabNameById = (tabId) => {
    tabId = tabId === null || tabId === void 0 ? void 0 : tabId.toString();
    switch (tabId) {
        case constants_1.TAB_TIER_IDS.TAB_PLUS: {
            return constants_1.TAB_TIER_LABELS.TAB_PLUS;
        }
        case constants_1.TAB_TIER_IDS.TAB_MID: {
            return constants_1.TAB_TIER_LABELS.TAB_MID;
        }
        case constants_1.TAB_TIER_IDS.TAB_BASIC: {
            return constants_1.TAB_TIER_LABELS.TAB_BASIC;
        }
        case constants_1.TAB_TIER_IDS.NO_TAB: {
            return constants_1.TAB_TIER_LABELS.NO_TAB;
        }
        case constants_1.TAB_TIER_IDS.BRING_YOUR_OWN_PHONE: {
            return constants_1.TAB_TIER_LABELS.BRING_YOUR_OWN_PHONE;
        }
        case constants_1.TAB_TIER_IDS.TAB_LITE: {
            return constants_1.TAB_TIER_LABELS.TAB_LITE;
        }
        default: {
            return '';
        }
    }
};
exports.getTabNameById = getTabNameById;
/**
 * Returns the priceTierId by contentful tab name
 *
 * @param {string} tabName - priceTierId
 * @returns {string } - tab name or empty string if no match
 */
const getByIdTabName = (tabName) => {
    switch (tabName) {
        case constants_1.TAB_TIER_LABELS.TAB_PLUS: {
            return constants_1.TAB_TIER_IDS.TAB_PLUS;
        }
        case constants_1.TAB_TIER_LABELS.TAB_MID: {
            return constants_1.TAB_TIER_IDS.TAB_MID;
        }
        case constants_1.TAB_TIER_LABELS.TAB_BASIC: {
            return constants_1.TAB_TIER_IDS.TAB_BASIC;
        }
        case constants_1.TAB_TIER_LABELS.NO_TAB: {
            return constants_1.TAB_TIER_IDS.NO_TAB;
        }
        case constants_1.TAB_TIER_LABELS.BRING_YOUR_OWN_PHONE: {
            return constants_1.TAB_TIER_IDS.BRING_YOUR_OWN_PHONE;
        }
        case constants_1.TAB_TIER_LABELS.TAB_LITE: {
            return constants_1.TAB_TIER_IDS.TAB_LITE;
        }
        default: {
            return '';
        }
    }
};
exports.getByIdTabName = getByIdTabName;
//# sourceMappingURL=getTabTeirs.js.map